import { Profile } from "@/integrations/supabase/types/subscription";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { CreditCard, Crown } from "lucide-react";

interface CurrentSubscriptionProps {
  profile: Profile;
}

export function CurrentSubscription({ profile }: CurrentSubscriptionProps) {
  const getStatusColor = (status: string | null) => {
    switch (status) {
      case "active":
        return "bg-green-500";
      case "trialing":
        return "bg-blue-500";
      case "past_due":
        return "bg-yellow-500";
      case "canceled":
        return "bg-gray-500";
      default:
        return "bg-gray-500";
    }
  };

  const formatSubscriptionStatus = (status: string | null) => {
    if (profile.notification_preferences?.is_admin) {
      return "SuperAdmin";
    }
    if (!status) return "Gratis";
    return status.charAt(0).toUpperCase() + status.slice(1).replace("_", " ");
  };

  return (
    <Card className="bg-muted/50 backdrop-blur-sm transition-shadow hover:shadow-md">
      <CardHeader className="space-y-1">
        <div className="flex items-center gap-2">
          {profile.notification_preferences?.is_admin ? (
            <Crown className="h-5 w-5 text-purple-500" />
          ) : (
            <CreditCard className="h-5 w-5 text-muted-foreground" />
          )}
          <CardTitle className="text-xl sm:text-2xl">Nåværende medlemskap</CardTitle>
        </div>
        <CardDescription className="text-sm sm:text-base">
          Din nåværende medlemskapsstatus
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-4">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium sm:text-base">Status</span>
            <Badge 
              className={`${
                profile.notification_preferences?.is_admin 
                  ? "bg-purple-500" 
                  : getStatusColor(profile.subscription_status)
              } text-xs sm:text-sm`}
            >
              {formatSubscriptionStatus(profile.subscription_status)}
            </Badge>
          </div>
          {profile.subscription_id && (
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium sm:text-base">Abonnement ID</span>
              <span className="text-xs text-muted-foreground sm:text-sm">
                {profile.subscription_id}
              </span>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}